import React from 'react'
import { List } from 'immutable'
import RowV3 from '../../Row.v3/index'
import { STYLES } from '../../Row.v3/utils'
import DetailPageV3CoursePracticeItem from './DetailPageV3CoursePracticeItem'

/**
 * Course detail page practices tiles tab component
 * @param {Object} props - The props
 * @param {List} props.practicesData - The practices data
 * @returns {JSX.Element} DetailPageV3CoursePractices
 */

function DetailPageV3CoursePractice (props) {
  const {
    practicesData = List(),
  } = props

  return (
      <div className="detail-page-v3__course-practice">
        <RowV3
          style={STYLES.S12234}
          asGrid={true}
        >
          {practicesData.map((item, index) => (
            <DetailPageV3CoursePracticeItem
              key={index}
              itemData={item}
            />
          ))}
        </RowV3>
      </div>
  )
}

export default DetailPageV3CoursePractice
